import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import './Header.css';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation(); // ✅ use react-router-dom's location

  const handleLogoClick = () => {
    navigate('/');
  };

  // Determine if it's a campus page
  const pathParts = location.pathname.split('/');
  const isCampusPage = pathParts[1] === 'gurukul' && pathParts[2];
  const campusName = isCampusPage ? pathParts[2].replace(/-/g, ' ').toUpperCase() : null;

  return (
    <header className="header">
      <div className="logo" onClick={handleLogoClick}>
        <img src="/logoJ.jpeg" alt="Gurukul Logo" />
        <div className="logo-text">
          <h1>SHRI KHETESHWAR GURUKUL</h1>
          <p>Fusion of Vedic wisdom and practical learning</p>
        </div>
      </div>

      {/* Campus Title (Only on campus pages) */}
      {isCampusPage && (
        <div className="campus-title-banner">
          <h2>{campusName}</h2>
        </div>
      )}

      <div className="nav-h">
        <Navbar />
      </div>
    </header>
  );
};

export default Header;
